import React, { useRef, useEffect } from 'react';
import { FiArchive, FiStar, FiUsers } from 'react-icons/fi';

interface ContactContextMenuProps {
    x: number;
    y: number;
    visible: boolean;
    onClose: () => void;
    onArchive: () => void;
    onFavorite: () => void;
    onAddToGroup: () => void;
    isArchived?: boolean;
    isFavorite?: boolean;
}

const ContactContextMenu: React.FC<ContactContextMenuProps> = ({
    x, y, visible, onClose, onArchive, onFavorite, onAddToGroup, isArchived, isFavorite
}) => {
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        if (visible) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [visible, onClose]);

    if (!visible) return null;

    const itemStyle: React.CSSProperties = {
        padding: '10px 15px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '14px',
        color: 'var(--text-primary)',
        transition: 'background-color 0.2s'
    };

    return (
        <div
            ref={menuRef}
            className="cweb-context-menu"
            style={{
                position: 'fixed',
                top: y,
                left: x,
                backgroundColor: 'var(--bg-card)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                borderRadius: '8px',
                padding: '5px 0',
                zIndex: 9999,
                minWidth: '180px',
                border: '1px solid var(--border-color)'
            }}
        >
            <div
                style={itemStyle}
                className="cweb-context-menu-item"
                onClick={(e) => { e.stopPropagation(); onArchive(); onClose(); }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--bg-hover)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
                <FiArchive size={16} color="var(--text-muted)" />
                {isArchived ? 'Unarchive' : 'Archive'}
            </div>
            <div
                style={itemStyle}
                className="cweb-context-menu-item"
                onClick={(e) => { e.stopPropagation(); onFavorite(); onClose(); }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--bg-hover)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
                <FiStar size={16} fill={isFavorite ? 'var(--warning-color)' : 'none'} color={isFavorite ? 'var(--warning-color)' : 'var(--text-tertiary)'} />
                {isFavorite ? 'Unfavorite' : 'Favorite'}
            </div>
            <div
                style={itemStyle}
                className="cweb-context-menu-item"
                onClick={(e) => { e.stopPropagation(); onAddToGroup(); onClose(); }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--bg-hover)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
                <FiUsers size={16} color="var(--text-muted)" />
                Manage Groups
            </div>
        </div>
    );
};

export default ContactContextMenu;
